import { AnimatedHidden } from "components/common/Keyboard/Keyboard.style";
import React, { useState } from "react";
import SimpleKeyboard from "react-simple-keyboard";

export const testIds = {
  keyboard: "keyboard-main"
};

interface IProps {
  isOpen: boolean;
  inputName: string;
  keyboardRef: any;
  onChange?(value: string): void;
  onEnterPressed?(): void;
  setIsOpen(isOpen: boolean): void;
}

enum Layout {
  Default = "default",
  Shift = "shift"
}

const Keyboard = ({
  onChange,
  onEnterPressed,
  keyboardRef,
  inputName,
  isOpen,
  setIsOpen
}: IProps) => {
  const [layoutName, setLayoutName] = useState(Layout.Default);
  const [isShift, setIsShift] = useState(false);
  const handleOnKeyPress = (keyPressed: string) => {
    if (keyPressed === "{enter}") {
      setIsOpen(false);
      if (onEnterPressed) {
        onEnterPressed();
      }
    }

    if (keyPressed === "{backspace}") {
      if (onChange) {
        onChange("");
      }
    }

    if (layoutName === Layout.Shift && isShift) {
      setLayoutName(Layout.Default);
      setIsShift(false);
    }

    if (["{shiftleft}", "{shiftright}"].includes(keyPressed)) {
      setIsShift(true);
      toggleLayout();
    }

    if (["{capslock}"].includes(keyPressed)) {
      toggleLayout();
    }
  };

  const toggleLayout = () =>
    setLayoutName(
      layoutName === Layout.Default ? Layout.Shift : Layout.Default
    );

  return (
    <AnimatedHidden isOpen={isOpen} testId={testIds.keyboard}>
      <SimpleKeyboard
        debug
        layoutName={layoutName}
        ref={keyboardRef}
        inputName={inputName}
        onChange={onChange}
        onKeyPress={handleOnKeyPress}
        layout={{
          default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{capslock} a s d f g h j k l ; ' {enter}",
            "{shiftleft} z x c v b n m , . / {shiftright}",
            ".com @ {space}"
          ],
          shift: [
            "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
            "{tab} Q W E R T Y U I O P { } |",
            '{capslock} A S D F G H J K L : " {enter}',
            "{shiftleft} Z X C V B N M < > ? {shiftright}",
            ".com @ {space}"
          ]
        }}
      />
    </AnimatedHidden>
  );
};

export default Keyboard;



// WEBPACK FOOTER //
// ./src/components/common/Keyboard/Keyboard.tsx